<template>
  <v-main>
    <div class="d-flex align-center justify-space-between flex-column"
    :class="(!isDark) ? 'world-bg' : 'world-bg-dark'">
      <v-container fluid class="pt-14 auth-form"></v-container>
      <v-form class="auth-form" @submit.prevent="recuperarSenha">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="center">
              <LogoTrinityLight routeName="Login" :width="200" class="mb-5" />
            </v-col>
            <v-col cols="12">
              <p class="font-weight-bold text-white">Redefinir senha</p>
              <p class="font-14 text-white">
                <!-- eslint-disable-next-line max-len -->
                Vamos te enviar um código de verificação por e-mail para que você possa alterar a sua senha.
                <br /><br />
                Não esqueça de verificar sua caixa de spam.
              </p>
              <p class="red--text" v-if="unexpectedError">{{ unexpectedError }}</p>
            </v-col>

            <v-col cols="12">
              <span class="mb-5 font-weight-bold d-block text-white">E-mail</span>
              <v-text-field
                type="email"
                placeholder="nome@email.com.br"
                solo
                hide-details
                class="mb-4 elevation-5"
                v-model="userData.email"
              >
                <template v-slot:append>
                  <v-icon large color="red" v-if="getError('email')">
                    mdi-alert
                  </v-icon>
                </template>
              </v-text-field>
              <p class="red--text" v-if="getError('email')">{{ getError('email') }}</p>
            </v-col>

            <v-col cols="12" class="text-center">
              <BtnEnviarCodigo></BtnEnviarCodigo>
              <br />
              <router-link
                :to="{ name: 'Login' }"
                class="text-center mb-10 font-14 bold-text text-white"
              >
                Voltar para Login
              </router-link>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-container fluid class="pb-14">
        <!-- <v-row>
          <p>Você não tem usuário? Clique aqui.</p>
        </v-row> -->
      </v-container>
    </div>

  </v-main>
</template>

<script>
import { mapActions } from 'vuex';
// eslint-disable-next-line import/no-cycle
import api from '@/services/api';
import LogoTrinityLight from '@/components/LogoTrinityLight.vue';
import BtnEnviarCodigo from '@/components/common/BtnEnviarCodigo.vue';
import * as yup from 'yup';

export default {
  name: 'ForgotPasswordView',
  components: {
    LogoTrinityLight,
    BtnEnviarCodigo,
  },
  data() {
    return {
      userData: {
        email: '',
        terms: false,
      },
      errors: [],
      unexpectedError: undefined,
      emailSended: false,
      termsOpen: false,
    };
  },
  methods: {
    ...mapActions(['toggleLoading']),
    getTextColor() { return (this.isDark) ? 'white--text' : 'black--text'; },
    async recuperarSenha() {
      this.toggleLoading(true);

      const schema = yup.object().shape({
        email: yup.string().email('O campo deve ser um e-mail.').required('Este campo é obrigatório.'),
      });

      try {
        await schema.validate(this.userData, {
          abortEarly: false,
        });

        const { email } = this.userData;

        await api.post('/autenticacao/recuperar', {
          email,
        });

        this.$router.push({
          name: 'RecuperarSenha',
          params: {
            email,
          },
        });
      } catch (err) {
        if (err.response) {
          this.errors = [
            {
              path: 'email',
              message: 'O e-mail inserido não pertence a uma conta. Verifique seu usuário e tente novamente.',
            },
          ];
        } else if (err.inner) {
          this.errors = err.inner;
        }
      }

      this.toggleLoading(false);
    },
    resetErrors() {
      this.errors = [];
      this.unexpectedError = undefined;
      this.emailSended = false;
    },
    getError(path) {
      const error = this.errors.find((err) => err.path === path);
      if (error) {
        return error.message;
      }
      return undefined;
    },
  },
};
</script>

<style>
</style>
